import { createAsyncThunk } from "@reduxjs/toolkit";
import setBaseURL from "../libs/utilities/helpers/BaseURLHelper";
import { api } from "./config/axiosConfig";
import { toggleComponentErrorPage } from "../reducers/componentErrorSlice";
import store from "../store/configureStore";

const DEV_BASE_URL = process.env.REACT_APP_BASE_URL_OTHER_SERVICES;

export const getDocFileBase64 = createAsyncThunk(
    "/sheet/file/download",
    async (data, { rejectWithValue }) => {
        try {
            setBaseURL(api, DEV_BASE_URL);
            const response = await api.post("/sheet/file/download", data, {
                headers: {
                },
            });
            if(response.status == 500){
                store.dispatch(toggleComponentErrorPage({ show: true }));
            }
            return response.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)
